import { render, staticRenderFns } from "./fmDeleteFile.vue?vue&type=template&id=b22d8888"
import script from "./fmDeleteFile.vue?vue&type=script&lang=js"
export * from "./fmDeleteFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports